import { IndexPage } from './IndexPage';
import { SetValidityPage } from './SetValidityPage';
import { SetStatusPage } from './SetStatusPage';
import { RemoveValidityPage } from './RemoveValidityPage';

export {
    IndexPage,
    SetValidityPage,
    SetStatusPage,
    RemoveValidityPage
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameConfigurations/index.ts
 **/